module.exports = __webpack_public_path__ + "img/serve17.f31e8163.png";